<template>
  <pt-order-new class="pt-order-new__withData"></pt-order-new>
</template>

<script>
import PtOrderNew from './index'
export default {
  name: 'pt-order-new__withData',
  components: {
    'pt-order-new': PtOrderNew
  }
}
</script>
